import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Spinner,
} from "reactstrap";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const getTodayDateString = () => {
  return new Date().toISOString().split("T")[0]; // YYYY-MM-DD
};

const DetectionChart = ({ date }) => {
  const [imgSrc, setImgSrc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const chartDate = date || getTodayDateString();

  useEffect(() => {
    const chartDate = date || getTodayDateString();
    const imgUrl = `${API_BASE}/media/charts/${chartDate}`;
    
    setLoading(true);
    setError(false);

    const testImage = new Image();
    testImage.onload = () => {
      setImgSrc(imgUrl);
      setLoading(false);
    };
    testImage.onerror = () => {
      setError(true);
      setLoading(false);
    };
    testImage.src = imgUrl;
  }, [date]);


  return (
    <Card className="shadow mt-4">
      <CardHeader>
        <CardTitle tag="h4">Hourly Detections for {chartDate}</CardTitle>
      </CardHeader>
      <CardBody className="text-center">
        {loading && <Spinner color="primary" />}
        {error && <p style={{ color: "gray" }}>No chart available for {chartDate}</p>}
        {!loading && !error && (
          <img
            src={imgSrc}
            alt={`Hourly Detections for ${chartDate}`}
            style={{ maxWidth: "100%", borderRadius: "8px" }}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default DetectionChart;
